import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyInput from '../../components/forms/input'
import MyImageUpload from '../../components/forms/imageUpload'
import MyRadio from '../../components/forms/radio'
import MyDatePicker from '../../components/forms/datePicker'

const EditMember = (props) => {
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  useEffect(() => {
    axios.post('/admin/user/detail/get', {
      user_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setFormValue(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [props.data])

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.name) {
      setErrorMsg({nameEmpty: '姓名不能为空'})
      return false
    }

    axios.post('/admin/user/edit', { 
      user_oid: props.data.oid,
      name: formValue.name,
      phone: formValue.phone,
      avatar_url: formValue.avatar_url,
      date_birth: formValue.date_birth,
      gender: formValue.gender
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getUserData()
          props.getUseDetail()
          message.success('修改成功！')
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    props.isCancel()
  }

  return (
    <Modal 
      title='编辑会员资料'
      destroyOnClose={true}
      width='400px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <MyInput
        id="name"
        required
        autoFocus
        maxLength={64}
        label='姓名'
        placeholder='请输入'
        value={formValue.name}
        onChange={setFormValue}
        errorMsg={errorMsg.nameEmpty}
      />

      <MyImageUpload
        id="avatar_url"
        label='头像'
        value={formValue.avatar_url}
        setValue={setFormValue}
      />

      <MyInput
        id="phone"
        maxLength={64}
        label='手机号'
        placeholder='请输入'
        value={formValue.phone}
        onChange={setFormValue}
      />

      <MyRadio
          id='gender'
          label='性别'
          options={[
            {
              label: '男',
              value: 1,
            },
            {
              label: '女',
              value: 2,
            }
          ]}
          defaultValue={1}
          value={formValue.gender}
          onChange={setFormValue}
        />

      <MyDatePicker
        id="date_birth"
        label='出生日期'
        placeholder='请选择'
        value={formValue.date_birth}
        onChange={setFormValue}
        styles={{width: '360px'}}
      />
    </Modal>
  )
}

export default EditMember
